import {DashboardUnavailableContainer} from "@containers"

const DashboardUnavailablePage = () => {
    return <DashboardUnavailableContainer />
}

export default DashboardUnavailablePage
